import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";
import RoommatesImage from "../Assets/Simulator_Screenshot_main.png";
import FirstIcon from "../Assets/first.png";
import SecondIcon from "../Assets/second.png";
import ThirdIcon from "../Assets/third.png";
import SimulatorScreenshot from "../Assets/aragonai.png";
import Footer from "./Footer";

const Home = () => {
  const [activeHowStep, setActiveHowStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveHowStep((prev) => (prev + 1) % 3);
    }, 3000); // 1.5 seconds per step
    return () => clearInterval(interval);
  }, []);

  return (
    <div id="home" className="home-container">
      <Navbar />
      <div className="home-banner-container">
        <div className="banner-content">
          <div className="home-text-section">
            <h1 className="primary-heading impressive-heading">
              מצא את
              <br />
              <span className="highlight">השותף המושלם</span>
              <br />
              עבורך בלחיצת כפתור
            </h1>
            <div className="hero-subheading">שותפים • מחפשים • דירות</div>

            <div className="description-text">
              <p>
                הכירו את <span className="rumiz-highlight">Rumiz</span> –
                האפליקציה החכמה שהופכת את תהליך חיפוש השותפים והדירות לפשוט!{" "}
              </p>
              <p>
                יוצרים פרופיל אישי ו-
                <span className="rumiz-highlight">Rumiz</span> תדאג למצוא לכם את
                השותפים הפוטנציאלים על בסיס לייף סטייל, תחומי עניין הרגלים
                והעדפות.
              </p>
              <p>
                גלו עכשיו את העולם של <span className="rumiz-highlight">Rumiz</span> עם מאגר שלם של שותפים ודירות שותפים
                המתאימים עבורכם
              </p>
            </div>
            <div className="store-buttons">
              <img
                src={require("../Assets/app_store.png")}
                alt="Download on the App Store"
                className="appstore-img"
                onClick={() => window.open("https://apps.apple.com/il/app/rumiz/id6749183949", "_blank")}
              />
              <img
                src={require("../Assets/play_store.png")}
                alt="Get it on Google Play"
                className="playstore-img"
                onClick={() => window.open("https://play.google.com/store/apps/details?id=com.rumiz.app", "_blank")}
              />
            </div>
          </div>

          <div className="banner-image">
            <img
              src={RoommatesImage}
              alt="שותפים מאושרים גרים יחד"
              className="hero-image"
              width="370"
              height="700"
            />
          </div>
        </div>
      </div>

      <div id="features-section" className="features-section">
        <h2>תכונות מרכזיות</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🤝</div>
            <h3>התאמה אישית חכמה</h3>
            <p>
              מצא שותפים מתאימים על בסיס לייף סטייל, <br />
              תחומי עניין, הרגלים והעדפות
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🇮🇱</div>
            <h3>ממשק כחול לבן</h3>
            <p>תמיכה מלאה בעברית וחיפוש בישראל</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💬</div>
            <h3>תקשורת בצ׳אט ישיר</h3>
            <p>צ'אט ישיר עם שותפים פוטנציאליים ובעלי דירות</p>
          </div>
        </div>
      </div>

      <div id="how-it-works-section" className="features-section">
        <h2>
          איך <span className="rumiz-highlight">Rumiz</span> עובד?
        </h2>
        <div className="how-steps">
          <div
            className={`how-step${
              activeHowStep === 0 ? " how-step-active" : ""
            }`}
          >
            <img src={FirstIcon} alt="שלב ראשון" className="how-step-icon" />
            <h3>נרשמים לאפליקציה</h3>
            <p>יוצרים משתמש וממלאים שאלון קצר</p>
          </div>
          <div
            className={`how-step${
              activeHowStep === 1 ? " how-step-active" : ""
            }`}
          >
            <img src={SecondIcon} alt="שלב ראשון" className="how-step-icon" />
            <h3>מזינים העדפות אישיות</h3>
            <p>
              מיקום, גיל, מגדר, הרגלים רצויים כמו ללא עישון, טבעוני, תחומי
              עיניין, סגנון לייף סטייל ועוד
            </p>
          </div>
          <div
            className={`how-step${
              activeHowStep === 2 ? " how-step-active" : ""
            }`}
          >
            <img src={ThirdIcon} alt="שלב ראשון" className="how-step-icon" />
            <h3>מוצאים בקלות</h3>
            <p>
              שולחים ומקבלים הצעות רלוונטיות, מדברים בצ'אט ישיר עם שותפים/בעלי
              דירות רלוונטיים ומתקדמים בקלות
            </p>
          </div>
        </div>
      </div>

      <div id="accuracy-section" className="features-section">
        <h2>
          כמה <span className="rumiz-highlight">Rumiz</span> מדויק?
        </h2>
        <div className="accuracy-content">
          <div className="accuracy-text">
            <p>
              האלגוריתם החכם של אפליקציית{" "}
              <span className="rumiz-highlight">Rumiz</span> עם דיוק של 90%
              בהתאמה אישית. על פי הנתונים שמילאת, מוצא לך מיידית שותפים עם תחומי
              עניין דומים ודירות שותפים מתאימות בקלות ויעילות רבה יותר.{" "}
            </p>
            <p>
              לכן מומלץ מאוד למלא פרופיל אישי מפורט, לציין בדיוק מה מחפשים
              ומעדיפים. ניתן לעדכן חיפוש והעדפות בכל שלב על מנת לקבל התאמה
              מושלמת.
            </p>
          </div>

          <div className="accuracy-cards">
            <img
              src={SimulatorScreenshot}
              alt="App Simulator Screenshot"
              className="simulator-image"
            />
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h2 className="cta-title">נסו את Rumiz היום!</h2>
        <div className="cta-subtitle">מצאו את השותפים שמתאימים לכם</div>
        <button
          className="cta-button"
          onClick={() =>
            document
              .getElementById("home")
              .scrollIntoView({ behavior: "smooth" })
          }
        >
          הורד עכשיו
        </button>
      </div>

      <div id="contact" className="signup-form-container">
        <h2>צרו קשר</h2>
        <p className="early-access-description">
          יש לכם שאלות, הצעות או רוצים לשתף פעולה? אנחנו ב{" "}
          <span className="rumiz-highlight">Rumiz</span> האפליקציה החכמה שהיא
          משפחה ובית עבורנו ובמיוחד נבנתה למצוא גם בית עבורכם, נשמח מאוד להכיר
          ולשמוע. משוב זה יסייע לנו לעזור לכם.
        </p>
        <form
          action="https://formspree.io/f/mpwdbebl"
          method="POST"
          className="signup-form"
        >
          <div className="form-group">
            <input
              type="text"
              placeholder="שם מלא"
              id="fullname"
              name="fullname"
              required
              className="form-input"
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              placeholder="אימייל"
              id="email"
              name="email"
              required
              className="form-input"
            />
          </div>
          <div className="form-group">
            <textarea
              placeholder="איך נוכל לעזור לך?"
              id="message"
              name="message"
              required
              className="form-input message-textarea"
              rows={4}
            />
          </div>
          <button type="submit" className="signup-button">
            שליחה <FiArrowRight />
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
